import { render, staticRenderFns } from "./ProductDropshipDetail.vue?vue&type=template&id=62c44564&scoped=true&"
import script from "./ProductDropshipDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDropshipDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductDropshipDetail.vue?vue&type=style&index=0&id=62c44564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c44564",
  null
  
)

export default component.exports